export default __webpack_public_path__ + "static/media/4.9f28607c.png";